<template>
  <div class="application">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="reg" />
    </header>
    <main>
      <section class="section-details" data-aos="fade-up">
        <!-- <section class="section-details__manage">
          <b-container>
            <div>
              <p>{{ $t("techInfo") }}</p>
            </div>
          </b-container>
        </section> -->
        <section class="section-details__missions">
          <b-container>
            <h4>{{ $t("regTasks.des") }}</h4>
            <ol>
              <b-row>
                <b-col sm="12" md="6">
                  <div class="pl-md-5">
                    <li>{{ $t("regTasks.li1") }}</li>
                    <li>
                      {{ $t("regTasks.li2") }}
                    </li>
                    <li>
                      {{ $t("regTasks.li3") }}
                    </li>
                    <li>{{ $t("regTasks.li4") }}</li>
                  </div>
                </b-col>
                <b-col sm="12" md="6">
                  <div class="pr-md-5">
                    <li>{{ $t("regTasks.li5") }}</li>
                    <li>
                      {{ $t("regTasks.li6") }}
                    </li>
                    <li>{{ $t("regTasks.li7") }}</li>
                    <li>
                      {{ $t("regTasks.li8") }}
                    </li>
                  </div>
                </b-col>
              </b-row>
            </ol>
          </b-container>
        </section>
      </section>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
// import { filesUrl } from "@/main";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";
export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    FooterComponent,
    MobileNav,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    if(localStorage.getItem("lang")=="en"){
    document.title = ` Al-Nisour University   - Registration Department`;
    document.querySelector('meta[name="title"]').setAttribute("content","Registration Department");
    document.querySelector('meta[name="description"]').setAttribute("content", "Acceptance of students in evening studies (general admission for middle school students - applied arts - professional (gifted) - corresponding institutes.");
    document.querySelector('meta[property="og:title"]').setAttribute("content","Registration Department");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "Acceptance of students in evening studies (general admission for middle school students - applied arts - professional (gifted) - corresponding institutes.");
    }else{
    document.title = `جامعة النسور  - قسم التسجيل`;
    document.querySelector('meta[name="title"]').setAttribute("content","قسم التسجيل");
    document.querySelector('meta[name="description"]').setAttribute("content", "قبول الطلبة في الدراسات المسائية (قبول العام لطلبة الاعدادية ـــ الفنون التطبيقية ــ المهني (الموهوبين ) ــ المعاهد المناظرة");
    document.querySelector('meta[property="og:title"]').setAttribute("content","قسم التسجيل");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "قبول الطلبة في الدراسات المسائية (قبول العام لطلبة الاعدادية ـــ الفنون التطبيقية ــ المهني (الموهوبين ) ــ المعاهد المناظرة");
    }
    document.querySelector('meta[property="og:image"]').setAttribute("content", `https://e-learn.nuc.edu.iq/images/logo.png`);
    // document.getElementById("icon").setAttribute("href",`${filesUrl}favicon.ico`); 
    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
};
</script>
